<micro-lookup domain="sms" obj="smsTypes" url="/sms/smsTypes" [key]="smsTypeId" [link]="link"></micro-lookup>
